import { Checkbox } from "@src/components/ui-components/Checkbox/Checkbox";
import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";

import { DeviationData } from "../../../Deviation/DeviationData";
import { SubtaskData } from "../../../Deviation/SubtaskData";
import { RoutineData } from "../../../Routines/RoutineData";
import { FirebaseDataDeviationField } from "../../DataObjectField/CustomFields/DeviationDataFields";

import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../../DataObjectField/Generic/FirebaseDataNumberField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";

export class DeviationSubtaskDataHelper extends DataObjectHelper<SubtaskData> {
  id = () => "deviationTask";
  displayName = () => t("main.deviationTask");

  title = new FirebaseDataStringField<SubtaskData>("title", t("main.title"), (data) => data.title, "build");
  description = new FirebaseDataStringField<SubtaskData>("description", t("main.description"), (data) => data.description, "build");
  dateField = new FirebaseDataDateField<SubtaskData>("deviationDate", t("main.date"), (task) =>
    task.parent instanceof DeviationData ? task.parent.reportDate : undefined
  );
  deviation = new FirebaseDataDeviationField("deviation", t("main.deviation"), (data) =>
    data.parent instanceof DeviationData ? data.parent : undefined
  );
  status = new FirebaseDataBooleanField<SubtaskData>("status", t("main.solved"), (data) => data.status?.id === 1);

  routine?: RoutineData;

  constructor(routine?: RoutineData) {
    super();
    this.routine = routine;
  }

  allFields(): DataObjectField<any, SubtaskData>[] {
    const fields: DataObjectField<any, SubtaskData>[] = [this.deviation, this.status, this.title, this.description, this.dateField];
    for (const task of this.routine?.tasks ?? []) {
      for (const field of task.fields) {
        if (field.valueType === "number") {
          fields.push(
            new FirebaseDataNumberField(task.id + "-" + field.id, field.title, (data) => {
              const instance = data.fields.find((instance) => instance.id === field.id);
              if (typeof instance?.value === "number") return instance.value;
              return undefined;
            })
          );
        }
      }
    }
    return fields;
  }
  getAllDataTableDatas(documents: SubtaskData[]): DataTableData[] {
    return documents.map((subtask) => {
      return {
        key: subtask.id,
        cells: {
          status: { element: <Checkbox value={subtask.status?.id === 1} />, rawString: subtask.status?.name },
          title: subtask.title,
          description: subtask.description,
          responsible: subtask.responsible.map((user) => user.name).join(", ") ?? t("main.notSpecified"),
          fields: subtask.fields.map((field) => field.title + ": " + field.value + field.unit).join(", "),
        },
      };
    });
  }
  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "status",
        title: t("main.status"),
      },
      {
        key: "title",
        title: t("main.title"),
      },
      {
        key: "description",
        title: t("main.description"),
      },
      {
        key: "responsible",
        title: t("main.responsible"),
      },
      {
        key: "fields",
        title: t("main.values"),
      },
    ];
  }
}

